import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

//Material UI
import { Grid, Typography, Paper } from '@mui/material';
import { Box, FormControll } from '@arredo/reactjs-ui'

// Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

//Components
import Table from '../../../components/table/tableAndPagination';

//Hooks
import useReferral from '../../../hooks/referrals/useReferral';

// Models
import { utils } from '../../../utils/utils';
import { stateTranslate, detailColumns } from '../../../models/ReferralEntities';

const ReferralDetailView = () => {
    const location = useLocation();
    const history = useNavigate();
    const { referralId } = useParams();
    const { referral, loading } = useReferral(referralId);

    const goBack = () => {
        if (!location.state)
            history('/stocks/referrals')
        else
            history(location.state.from);
    }

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Box
                    icon={
                        <>
                            <ArrowBackIcon />
                        </>
                    }
                    onIconClick={goBack}
                    header={
                        <Typography variant='h5' component='h4'>
                            {referral.number} | Remito
                        </Typography>
                    }
                >
                </Box>
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    md: 3
                }}
            >
                <Box header={
                    <Grid size={12}>
                        <Typography component='h2' variant='h6'>
                            Datos del Remito
                        </Typography>
                    </Grid>
                }
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <FormControll label='N° de Remito' value={referral.number} />
                            <FormControll label='Creado' value={utils.formatDate(referral.created)} />
                            <FormControll label='Remitido' value={referral.remitedDate ? utils.formatDate(referral.remitedDate) : ''} />
                            <FormControll label='Origen' value={referral.warehouseOrigen?.name} />
                            <FormControll label='Destino' value={referral.warehouseDestination?.name} />
                            <FormControll label='Estado' value={stateTranslate[referral.state]} />
                            {referral.shipmentNumber &&
                                <FormControll label='Numero de Envio' value={referral.shipmentNumber} />
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    md: 9
                }}
            >
                <Paper>
                    <Table
                        title='Productos'
                        rows={referral.details}
                        columns={detailColumns}
                        loading={loading}
                        count={referral.details?.length}
                    />
                </Paper>
            </Grid>
        </Grid>
    );
}

export default ReferralDetailView;